/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Profilelinkdisconnecttitle3Inputs */

const en_profilelinkdisconnecttitle3 = /** @type {(inputs: Profilelinkdisconnecttitle3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Disconnect ${i?.name}?`)
};

const de_profilelinkdisconnecttitle3 = /** @type {(inputs: Profilelinkdisconnecttitle3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} trennen?`)
};

/**
* | output |
* | --- |
* | "Disconnect {name}?" |
*
* @param {Profilelinkdisconnecttitle3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const profilelinkdisconnecttitle3 = /** @type {((inputs: Profilelinkdisconnecttitle3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profilelinkdisconnecttitle3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_profilelinkdisconnecttitle3(inputs)
	return de_profilelinkdisconnecttitle3(inputs)
});
export { profilelinkdisconnecttitle3 as "profileLinkDisconnectTitle" }